import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const CreateRoleSchema = T.Object({
  name: T.String({ minLength: 1, error: 'Nome do cargo é um campo obrigatório' }),
  permissions: T.Array(T.String({ format: 'uuid' }), {
    error: 'Permissão deve ser um uuid',
  }),
});

export type CreateRoleInputType = typeof CreateRoleSchema.static;

export async function ValidateCreateRoleInput(value: unknown): Promise<CreateRoleInputType> {
  return Value.Parse(CreateRoleSchema, value);
}

export function checkRoleCreateInput(field: string, value: unknown): string | boolean {
  return validateField(CreateRoleSchema, field, value);
}
